import { Platform } from 'react-native';
import * as SplashScreen from 'expo-splash-screen';
import './src/unistyles';
import {
  installClientConsoleForwarding,
  installGlobalErrorHandler,
  maybeInitBrowserLogs,
  maybeInitBrowserRum,
  trackRumAction,
} from './src/lib/datadog';

import 'expo-router/entry';

async function bootstrap() {
  if (Platform.OS !== 'web') {
    try {
      await SplashScreen.preventAutoHideAsync();
    } catch {
      // Ignore errors if splash screen is already hidden or native module missing
    }
  }
  maybeInitBrowserRum();
  maybeInitBrowserLogs();
  installClientConsoleForwarding();
  installGlobalErrorHandler();
  trackRumAction('bootstrap_start');
}

trackRumAction('register_root_component');
void bootstrap();
